import { Box, Container } from "@chakra-ui/react";
import { ReactNode } from "react";

export type SectionVariant = "white" | "grey" | "cream" | "beige";

type SectionProps = {
  children: ReactNode;
  /** @deprecated Prefer `variant` */
  color?: "white" | "grey";
  variant?: SectionVariant;
  id?: string;
  containerMaxW?: string;
};

const variantBg: Record<SectionVariant, string> = {
  white: "white",
  grey: "lp_grey.100",
  /** Warm band below hero — distinct from `preview.background` on Hero */
  cream: "cle.cream",
  beige: "cle.beige",
};

const Section = ({ children, color, variant, id, containerMaxW = "6xl" }: SectionProps) => {
  const resolved: SectionVariant =
    variant ?? (color === "grey" ? "grey" : "white");

  return (
    <Box
      id={id}
      position="relative"
      zIndex={1}
      backgroundColor={variantBg[resolved]}
    >
      <Container maxW={containerMaxW} px={{ base: 6, md: 8 }}>
        {children}
      </Container>
    </Box>
  );
};

export default Section;
